import { Typography } from '@mui/material';
import Currency from '@product-framework/components/Currency';

function MultiValueDisplay({ title, type = null, children, ...rest }) {
  return (
    <Typography component="p" {...rest}>
      <Typography sx={{ fontSize: '13px' }} component="div">
        {title}
      </Typography>
      {type === 'currency' ? (
        <Currency {...(rest.color && { color: rest.color })}>
          {children}
        </Currency>
      ) : (
        children
      )}
    </Typography>
  );
}

export default MultiValueDisplay;
